module.exports = __webpack_public_path__ + "static/img/Quienes Somos.2de8e36c.png";